<template>
  <q-field
    stack-label
    borderless
    dense
    bottom-slots
    hide-bottom-space
    :label="label"
    :error="!!errorMessage"
    :error-message="errorMessage"
  >
    <ColorBadge
      v-ripple
      class="cursor-pointer"
      :value="modelValue"
      :dense="dense"
      :dynamic-colors="dynamicColors"
      :label="label"
      :inner-label="innerLabel"
      :icon="icon"
      :width="width"
      :height="height"
      :shadow="shadow"
    >
      <responsive-menu
        v-if="!disable"
        ref="menu"
        :breakpoint="1024"
        toolbar-title="Select Colour"
        no-refocus="mobile"
        force-on-mobile
        card-style="width: 300px;"
        @hide="$emit('hide')"
      >
        <q-card-section>
          <color-picker
            v-bind="{ modelValue, disable, clearable, allowDynamics, dynamicColors }"
            @update:model-value="$emit('update:modelValue', $event)"
            @hide="$refs.menu.close()"
            @clear="$emit('clear')"
            @change-tab="$nextTick(() => $refs.menu.updatePosition())"
          >
            <template #dynamic-description>
              <slot name="dynamic-description" />
            </template>
          </color-picker>
        </q-card-section>
      </responsive-menu>

      <slot />
    </ColorBadge>
  </q-field>
</template>

<script>
import ColorBadge from './ColorBadge'

/**
 * Uses default QColor but adds it as a popover element
 */
export default {
  components: {
    ColorBadge
  },
  props: {
    modelValue: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    },
    label: {
      type: String
    },
    innerLabel: {
      type: String
    },
    dense: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String
    },
    width: {
      type: String
    },
    height: {
      type: String
    },
    disable: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    allowDynamics: {
      type: Boolean,
      default: false
    },
    dynamicColors: {
      type: Object,
      default: null,
      validator: (value) => {
        return !!value && typeof value === 'object'
      }
    }
  },
  emits: ['hide', 'update:modelValue', 'clear'],
  computed: {
    isTransparent () {
      return !this.modelValue || this.modelValue === 'transparent'
    },
    defaultColor () {
      return this.clearable ? null : '#027be3'
    }
  },
  created () {
    if (this.isTransparent && !this.clearable) {
      this.$emit('update:modelValue', this.defaultColor)
    }
  },
  mounted () {
    if (!this.disable && this.autofocus) {
      setTimeout(() => [
        this.$refs.menu.open()
      ], 250)
    }
  }
}
</script>
